'use strict';

/**
 * Selection helpers for the avoidances selector.
 *
 * The recompute block was duplicated in toggleAvoidance and toggleExcludeFood;
 * this is the single source of truth.
 */

/**
 * Recompute the `selected` flag on every option from the current selections.
 *
 * A row is selected when it is avoided itself, or when any category in its
 * `parents` chain is avoided. The parents check matters for lazy-loaded foods:
 * their `ancestor_keys` can miss the category they were loaded under, so the
 * ancestor_keys check alone would unhighlight them.
 *
 * @param {Array}  avoidOptions  the flattened option list
 * @param {Object} avoidResults  uuid -> result (carries category_key / ancestor_keys)
 * @param {Array}  avoidances    selected category keys
 * @param {Array}  excludeFoods  selected food uuids
 * @returns {Array} a new options array with updated `selected` flags
 */
export function recomputeOptionSelection(avoidOptions, avoidResults, avoidances, excludeFoods) {
    return avoidOptions.map(option => {
        const isCategory = option.type === 'category';
        const avoidResult = avoidResults[option.value];
        const parentAvoided = (option.parents || []).some(parent => avoidances.includes(parent));
        const selected = isCategory
            ? avoidances.includes(avoidResult.category_key) || parentAvoided
            : excludeFoods.includes(option.value)
                || parentAvoided
                || avoidances.some(avoidance => (avoidResult.ancestor_keys || []).includes(avoidance));
        return { ...option, selected };
    });
}
